<div class="fileUploaderList">
  <ng-container *ngFor="let item of files; let i = index">
    <vc-file-uploader-document
      [file]="item"
      class="fileUploaderList__entry"
      (onFileRemove)="removeFile(i)"
    ></vc-file-uploader-document>
  </ng-container>
  <button class="fileUploaderList__entry fileUploaderList__entry--add" (click)="fileUploaderInput.click()"></button>
  <input hidden type="file" [accept]="acceptableExtensions.join(', ')" (change)="addFile($event)" #fileUploaderInput />
</div>
